import { render, staticRenderFns } from "./damage.vue?vue&type=template&id=4ca77cca&"
import script from "./damage.vue?vue&type=script&lang=js&"
export * from "./damage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports